import { ECurrency } from '@core/type';

export const currencySymbol = {
  [ECurrency.EUR]: '€',
  [ECurrency.CHF]: '₣',
  [ECurrency.USD]: '$',
  [ECurrency.GBP]: '£',
};
